import {TSyncfield_User} from "../../../constants/Syncfields";

export namespace nsUserWizard {
    export const WizardSyncfieldNames: readonly TSyncfield_User[] = [
        'GivenName',
        'Surname',
        'DisplayName',
        'Socialsecuritynumber',
        'EmployeeNumber',
        'SourceId',
        'Title',
        'APositionCodeName',
        'Mobile',
        'PrivatePhone',
        'PrivateEmail',
        'Start',
        'APositionStartDate',
        'ExpiryDate',
        'Stop',
        'APositionEndDate',
        'APrimaryPosition',
        'Department',
        'AUnitName',
        'DepartmentNumber',
        'AUnitId',
        'ParentDepartmentNumber',
        'Manager',
        'APositionManager',
        'WwwUrl',
        'ManualMerge',
        'Company',
        'ACompany',
    ] as const

    export type TWizardSyncfield = typeof WizardSyncfieldNames[number]

    export enum Step {
        Personalia,
        PrimaryPosition,
        SecondaryPositions,
        Summary,
        Processing,
        Success,
        Error,
    }

    export const GENERATE_EMPLOYEE_NUMBER_STRING = '[HASH;[Socialsecuritynumber]]';

    export const WizardOptionalPositionSyncfieldNames: readonly TSyncfield_User[] = [
        'AAuthorizedPositionName',
        'ABusinessNumber',
        'ACostCentre1',
        'ACostCentre10',
        'ACostCentre2',
        'ACostCentre3',
        'ACostCentre4',
        'ACostCentre5',
        'ACostCentre6',
        'ACostCentre7',
        'ACostCentre8',
        'ACostCentre9',
        'ACostCentreName1',
        'ACostCentreName2',
        'ACostCentreName3',
        'ACostCentreName4',
        'ACostCentreName5',
        'AEmployeeNumber',
        'AEmployeeTypeCodeDescription',
        'AEmploymentPositionPercentage',
        'ALeaveFromDate',
        'ALeavePercentage',
        'ALeaveReason',
        'ALeaveToDate',
        'ALeaveType',
        'ALocation',
        'APaymentLocationName',
        'APaymentLocationValue',
        'APositionCategoryNumber',
        'APositionCodeCode',
        'APositionCodeId',
        'APositionId',
        'APositionPercentage',
        'APositionPublicCode',
        'APositionPublicCodeName',
        'APositionSalaryEndDate',
        'APositionTypeName',
        'APositionTypeValue',
        'AQualificationCode',
        'AServicePlaceId',
        'AServicePlaceName',
        'AShiftWork',
        'AUserId',
        'AValidFromDate',
        'AWeeklyHours',
        'AWorkClassificationName',
        'AYearlyHours',
    ] as const

    export type TWizardOptionalPositionSyncfieldName = typeof WizardOptionalPositionSyncfieldNames[number]

    export type TPositionType = 'primary' | 'secondary'

}